import React, { useEffect, useState } from 'react'
import { Grid, TextField, FormControl, ThemeProvider, createTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../../Store/Hooks'
import { showAlert } from '../../../../Store/Slice/alert.slice'
import { MUIBox, MUIButton } from '../../../Shared'
import MuiAutocompleteWithoutControl from '../../../Shared/MUI-AutoCompleteSingleSelect-NoController'
import { setLoader } from '../../../../Store/Slice/loader.slice'
import mainApiService from '../../../../Services'
import { MASTERS_MANAGEMENT } from '../../../../Constants/ApiDefinations'
import CONSTANTS, { PAGES_ROUTES } from '../../../../Constants'
import * as yup from 'yup'
import {
  combineErrorMessage,
  convertHyphenatedString,
  fetchCategory,
  getCountryDataFormSegmentMaster,
  getMasterPayload,
  getPackFamily,
  handleResponse,
  toCamelCase,
} from '../../../../Helpers/Util'
import {
  selectBlitzMasterConfigurationData,
  selectMasterData,
  selectSystemConfigurationData,
} from '../../../../Store/Slice/masters.slice'
interface SystemConfigurationFormPropsInterface {
  mastersPageType: string
  masterObj: string
  mastersId?: string
  editSystemConfig?: any
  isBlitzMasterConfig?: boolean
}

const theme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: '#D4351C' },
      },
    },
  },
})
const SystemConfigurationForm = ({
  mastersPageType,
  masterObj,
  mastersId,
  editSystemConfig,
  isBlitzMasterConfig,
}: SystemConfigurationFormPropsInterface) => {
  const SegmentMasterData = useAppSelector(selectMasterData)
  const systemConfigListData = useAppSelector(selectSystemConfigurationData)
  const blitzMasterConfigListData = useAppSelector(selectBlitzMasterConfigurationData)

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [formState, setFormState] = useState<any[]>([])

  const reusedLabelValue = [
    { label: 'Key', name: 'key', type: 'text', required: true },
    { label: 'Value', name: 'value', type: 'text', required: true },
    {
      label: 'Status',
      name: 'status',
      type: 'select',
      options: CONSTANTS.ROLE_STATUS,
      required: true,
    },
  ]
  const fieldsForLayouts = [
    { label: 'Type', name: 'type', type: 'text', required: true },
    {
      label: 'Layout',
      name: 'layout',
      type: 'text',
      required: true,
    },
    {
      label: 'OS Field',
      name: 'osField',
      type: 'text',
      required: true,
    },
    {
      label: 'Click URL',
      name: 'clickUrl',
      type: 'select',
      options: CONSTANTS.TRUE_FALSE_BOOLEAN,
      required: false,
    },
    {
      label: 'Status',
      name: 'status',
      type: 'select',
      options: CONSTANTS.ROLE_STATUS,
      required: true,
    },
  ]
  const segmentFieldConfig: any = {
    country: [...reusedLabelValue],
    state: [
      {
        label: 'Country',
        name: 'countryId',
        type: 'select',
        required: true,
      },
      ...reusedLabelValue,
    ],
    'pack-name': [
      {
        label: 'Pack Family',
        name: 'packFamilyId',
        type: 'select',
        required: true,
      },
      ...reusedLabelValue,
    ],
    'pack-family': [
      {
        label: 'Country',
        name: 'countries',
        type: 'select',
        labelValue: 'countryName',
        required: true,
      },
      ...reusedLabelValue,
    ],
    'ab-segment': [...reusedLabelValue],
    'publishing-segment': [...reusedLabelValue],
    platform: [
      ...reusedLabelValue,
      {
        label: 'Category',
        name: 'category',
        type: 'select',
        labelValue: 'category',
        required: false,
      },
    ],
    cluster: [...reusedLabelValue],
    segment: [
      { label: 'Value', name: 'value', type: 'text', required: true },
      {
        label: 'Status',
        name: 'status',
        type: 'select',
        options: CONSTANTS.ROLE_STATUS,
        required: true,
      },
    ],
    widget: [
      ...fieldsForLayouts,
      {
        label: 'Bulk Upload',
        name: 'bulkUpload',
        type: 'select',
        options: CONSTANTS.TRUE_FALSE_BOOLEAN,
        required: false,
      },
    ],
    container: [...fieldsForLayouts],
    'iris-segment': [...reusedLabelValue],
  }
  const segmentFields = segmentFieldConfig[masterObj] || [
    { label: 'Key', name: 'key', type: 'text', required: true },
    { label: 'Value', name: 'value', type: 'text', required: true },
  ]

  useEffect(() => {
    if (!masterObj) return
    const fetchData = async () => {
      await fetchOptions()
    }

    fetchData()
  }, [masterObj])

  const fetchOptions = async () => {
    dispatch(setLoader(true))
    if (masterObj === 'state' || masterObj === 'pack-family') {
      const updatedFields = await Promise.all(
        segmentFields.map(async (field: any) => {
          if (
            (field.name === 'countryId' || field.name === 'countries') &&
            field.type === 'select'
          ) {
            return {
              ...field,
              options: await getCountryDataFormSegmentMaster(),
            }
          }
          return field
        }),
      )
      dispatch(setLoader(false))
      return setFormState(updatedFields)
    } else if (masterObj === 'pack-name') {
      const updatedFields = await Promise.all(
        segmentFields.map(async (field: any) => {
          if (field.name === 'packFamilyId' && field.type === 'select') {
            return {
              ...field,
              options: await getPackFamily(),
            }
          }
          return field
        }),
      )
      dispatch(setLoader(false))
      return setFormState(updatedFields)
    } else if (masterObj === 'platform') {
      const updatedFields = await Promise.all(
        segmentFields.map(async (field: any) => {
          if (field.name === 'category' && field.type === 'select') {
            return {
              ...field,
              options: await fetchCategory(),
            }
          }

          return field
        }),
      )
      dispatch(setLoader(false))
      return setFormState(updatedFields)
    }
    dispatch(setLoader(false))
    setFormState(segmentFields)
  }

  const initialFormState = formState?.reduce((acc: any, field: any) => {
    acc[field.name] = editSystemConfig ? editSystemConfig[field.name] : ''
    return acc
  }, {})

  initialFormState.status = editSystemConfig?.status || 'ACTIVE'
  initialFormState.clickUrl = editSystemConfig?.clickUrl ?? true
  initialFormState.bulkUpload = editSystemConfig?.bulkUpload ?? false
  const [formValues, setFormValues] = useState(initialFormState)
  const [formErrors, setFormErrors] = useState<any>({})
  useEffect(() => {
    if (mastersPageType === CONSTANTS.PAGE_TYPE.EDIT && editSystemConfig) {
      setFormValues({
        ...editSystemConfig,
        status: editSystemConfig.status || 'ACTIVE',
        clickUrl: editSystemConfig.clickUrl ?? true,
        bulkUpload: editSystemConfig?.bulkUpload ?? false,
      })
    }
  }, [editSystemConfig, mastersPageType])

  const handleInputChange = (e: any) => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
    if (formErrors?.[name]) {
      validateField(name, value)
    }
  }

  const validateField = (name: string, value: string) => {
    let error = ''
    if (!value.trim()) {
      error = `${name.charAt(0).toUpperCase() + name.slice(1)} field is required.`
    }
    setFormErrors((prevErrors: any) => ({ ...prevErrors, [name]: error }))
  }

  const validateForm = () => {
    const errors: Record<string, string> = {}

    formState?.forEach((field: any) => {
      const value = formValues[field?.name]
      if (
        field?.required &&
        (!value ||
          (typeof value === 'string' && !value.trim()) ||
          (Array.isArray(value) && value?.length === 0))
      ) {
        errors[field?.name] = `${field?.label} field is required.`
      }
    })

    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }
  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (!validateForm()) {
      return
    }

    if (masterObj !== 'widget') {
      delete formValues?.bulkUpload
    }

    if (masterObj === 'iris-segment') {
      delete formValues?.irisSegment
    }

    try {
      let result: any
      if (mastersPageType === CONSTANTS.PAGE_TYPE.CREATE) {
        if (isBlitzMasterConfig) {
          dispatch(setLoader(true))
          const payload = getMasterPayload(
            blitzMasterConfigListData[toCamelCase(masterObj)],
            formValues,
          )
          const requestedData: any =
            MASTERS_MANAGEMENT.BLITZ_MASTER_CONFIGURATION_CRUD.CREATE(payload)
          result = await mainApiService(requestedData)
          dispatch(setLoader(false))
        } else if (SegmentMasterData?.includes(masterObj.toLowerCase())) {
          dispatch(setLoader(true))
          let updatedFormValues = { ...formValues }
          delete updatedFormValues.clickUrl

          if (masterObj === 'pack-family') {
            const countryData = formState[0].options.find(
              (data: any) => data?.value === formValues?.countries,
            )
            updatedFormValues = {
              ...updatedFormValues,
              countries: [
                {
                  countryName: countryData?.label ?? '',
                  countryId: countryData?.value ?? '',
                  countryCode: countryData?.key ?? '',
                },
              ],
            }
          }

          let requestedData: any
          if (['ab-segment', 'publishing-segment'].includes(masterObj)) {
            requestedData = MASTERS_MANAGEMENT.SEGMENT_MASTER.CREATE_WITHOUT_MASTER(
              masterObj,
              updatedFormValues,
            )
          } else {
            requestedData = MASTERS_MANAGEMENT.SEGMENT_MASTER.CREATE(masterObj, updatedFormValues)
          }
          result = await mainApiService(requestedData)
          dispatch(setLoader(false))
        } else if (systemConfigListData?.includes(masterObj.toLowerCase())) {
          const payload = getMasterPayload(masterObj.replaceAll('-', '_').toUpperCase(), formValues)
          const requestedData: any = MASTERS_MANAGEMENT.SYSTEM_CONFIGURATION_CRUD.CREATE(payload)
          result = await mainApiService(requestedData)
        } else {
          const { key, value, ...updatedFormValues } = formValues
          updatedFormValues.module = masterObj
          const requestedData: any =
            MASTERS_MANAGEMENT.LAYOUT_CONFIGURATION_CRUD.CREATE(updatedFormValues)
          result = await mainApiService(requestedData)
          dispatch(setLoader(false))
        }
      }
      if (mastersPageType === CONSTANTS.PAGE_TYPE.EDIT && mastersId) {
        if (isBlitzMasterConfig) {
          dispatch(setLoader(true))
          const payload = {
            blitzMasterConfigId: mastersId,
            ...getMasterPayload(blitzMasterConfigListData[toCamelCase(masterObj)], formValues),
          }
          const requestedData: any =
            MASTERS_MANAGEMENT.BLITZ_MASTER_CONFIGURATION_CRUD.UPDATE(payload)
          result = await mainApiService(requestedData)
          dispatch(setLoader(false))
        } else if (SegmentMasterData?.includes(masterObj.toLowerCase())) {
          dispatch(setLoader(true))
          let updatedData = { ...formValues }

          if (masterObj === 'pack-family') {
            const countryData = formState?.[0]?.options.filter(
              (data: any) => data?.value === formValues?.countries,
            )
            updatedData = {
              ...updatedData,
              countries: [
                {
                  countryName: countryData?.[0]?.label ?? '',
                  countryId: countryData?.[0]?.value ?? '',
                  countryCode: countryData?.[0]?.key ?? '',
                },
              ],
            }
          }

          const editData = {
            ...updatedData,
            [convertHyphenatedString(masterObj) + 'Id']: mastersId,
          }
          let requestedData: any
          if (['ab-segment', 'publishing-segment'].includes(masterObj)) {
            requestedData = MASTERS_MANAGEMENT.SEGMENT_MASTER.UPDATE_WITHOUT_MASTER(
              masterObj,
              editData,
            )
          } else {
            requestedData = MASTERS_MANAGEMENT.SEGMENT_MASTER.UPDATE(masterObj, editData)
          }
          result = await mainApiService(requestedData)
          dispatch(setLoader(false))
        } else if (systemConfigListData?.includes(masterObj.toLowerCase())) {
          let payload: any = getMasterPayload(
            masterObj.replaceAll('-', '_').toUpperCase(),
            formValues,
          )
          payload = {
            ...payload,
            systemConfigId: mastersId,
          }
          const requestedData: any = MASTERS_MANAGEMENT.SYSTEM_CONFIGURATION_CRUD.UPDATE(payload)
          result = await mainApiService(requestedData)
        } else {
          if (masterObj !== 'widget') {
            delete formValues?.bulkUpload
          }

          const { createdBy, updatedBy, ...updatedFormValues } = formValues
          updatedFormValues.module = masterObj
          updatedFormValues.layoutId = mastersId
          const requestedData: any =
            MASTERS_MANAGEMENT.LAYOUT_CONFIGURATION_CRUD.UPDATE(updatedFormValues)
          result = await mainApiService(requestedData)
          dispatch(setLoader(false))
        }
      }
      const { error, message } = handleResponse(result)
      if (error) {
        dispatch(showAlert([true, combineErrorMessage(result), 'error']))
        return
      }
      dispatch(showAlert([true, message, 'success']))
      const masterListNavigationUrl = isBlitzMasterConfig
        ? `/${PAGES_ROUTES.blitzMasterConfig}`
        : ''
      navigate(
        `/${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.Masters}${masterListNavigationUrl}/${masterObj}`,
      )
    } catch (error_) {
      const errors = (error_ as yup.ValidationError)?.inner?.reduce(
        (acc: any, error: yup.ValidationError) => {
          acc[error.path!] = error.message
          return acc
        },
        {},
      )
      setFormErrors(errors)
    }
  }

  const renderFormFields = () => {
    return formState.map((field: any) => (
      <Grid item xs={6} key={`${field.name}-${field.label}`}>
        {field.type === 'text' && (
          <FormControl fullWidth error={Boolean(formErrors?.[field.name])}>
            <TextField
              fullWidth
              label={
                <span>
                  {field.label}
                  {field.required && <span style={{ color: '#D4351C' }}>*</span>}
                </span>
              }
              name={field.name}
              type='text'
              value={formValues?.[field.name]}
              onChange={handleInputChange}
              error={Boolean(formErrors?.[field.name])}
              helperText={formErrors?.[field.name]}
              inputProps={{ maxLength: 100 }}
              data-testid={field.name}
            />
          </FormControl>
        )}
        {field.type === 'select' && (
          <MuiAutocompleteWithoutControl
            name={field.name}
            label={field.label}
            required={field.required}
            value={formValues?.[field.name]}
            options={field?.options || []}
            error={
              formErrors?.[field.name]
                ? { [field.name]: { message: formErrors[field.name] } }
                : undefined
            }
            onChange={(val: any) => {
              handleInputChange({ target: { name: field.name, value: val } })
            }}
          />
        )}
      </Grid>
    ))
  }

  return (
    <MUIBox>
      <div className='heading-6 d-flex  rolebox__header-padding' style={{ padding: 12 }}>
        {masterObj?.split('-')?.join(' ')}
      </div>
      <div className={'hr'}></div>
      <ThemeProvider theme={theme}>
        {formState?.length > 0 && (
          <form onSubmit={onSubmit}>
            <Grid padding={2} container spacing={3} columnSpacing={10} rowSpacing={4}>
              {renderFormFields()}
              <Grid item xs={12}>
                <MUIButton
                  className='c-btn'
                  type='submit'
                  variant='contained'
                  label={mastersPageType === CONSTANTS.PAGE_TYPE.CREATE ? 'Create' : 'Update'}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </ThemeProvider>
    </MUIBox>
  )
}
export default SystemConfigurationForm
